import { mergeStyleSets } from "@fluentui/react";

export const getQuestionFormStyle = () => {
	return mergeStyleSets({
		root: {
			backgroundColor: "white",
			paddding: "10px",
		},
	});
};
